export default __webpack_public_path__ + "static/media/solar-panel.d7d441d7.jpg";